import React, { useEffect, useState } from 'react';
import Header from './Header';
import API_URL from '../config';

const listaTipoAmbiente = [
  { value: 1, label: 'IMPRESSÃO REMOTA' },
  { value: 2, label: 'IMPRESSÃO NO EQUIPAMENTO' }
];
const listaImpressoraTipo = [
  { value: '58mm', label: '58mm' },
  { value: '72mm', label: '72mm' },
  { value: '80mm', label: '80mm' }
];

function AmbientesPage({ empresa, usuario, onVoltar, onSair }) {
  const [ambientes, setAmbientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [modalAberto, setModalAberto] = useState(false);
  const [form, setForm] = useState({
    id: null,
    nome: '',
    impressora_ip: '',
    impressora_porta: '',
    tipo_ambiente: '',
    impressora_tipo: ''
  });
  const [editando, setEditando] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [confirmarExclusao, setConfirmarExclusao] = useState({ aberto: false, id: null });

  const fetchAmbientes = async () => {
    setLoading(true);
    setErro('');
    try {
      const res = await fetch(`${API_URL}/ambientes?empresa_id=${empresa.id}`);
      const data = await res.json();
      setAmbientes(Array.isArray(data) ? data : []);
    } catch (err) {
      setErro('Erro ao buscar ambientes');
      setAmbientes([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchAmbientes();
    // eslint-disable-next-line
  }, [empresa.id]);

  const abrirModal = (ambiente = null) => {
    if (ambiente) {
      setForm({
        id: ambiente.id,
        nome: ambiente.nome,
        impressora_ip: ambiente.impressora_ip || '',
        impressora_porta: ambiente.impressora_porta === 0 || ambiente.impressora_porta === null ? '' : String(ambiente.impressora_porta),
        tipo_ambiente: ambiente.tipo_ambiente || '',
        impressora_tipo: ambiente.impressora_tipo || ''
      });
      setEditando(true);
    } else {
      setForm({ id: null, nome: '', impressora_ip: '', impressora_porta: '', tipo_ambiente: '', impressora_tipo: '' });
      setEditando(false);
    }
    setErro('');
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setForm({ id: null, nome: '', impressora_ip: '', impressora_porta: '', tipo_ambiente: '', impressora_tipo: '' });
    setEditando(false);
    setErro('');
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setErro('');
    if (!form.nome) {
      setErro('Preencha o campo Nome!');
      return;
    }
    try {
      const method = editando ? 'PUT' : 'POST';
      const url = editando ? `${API_URL}/ambientes/${form.id}` : `${API_URL}/ambientes`;
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          empresa_id: empresa.id,
          nome: form.nome,
          impressora_ip: form.impressora_ip,
          impressora_porta: form.impressora_porta,
          tipo_ambiente: form.tipo_ambiente,
          impressora_tipo: form.impressora_tipo
        })
      });
      if (!res.ok) throw new Error('Erro ao salvar ambiente');
      fecharModal();
      fetchAmbientes();
    } catch (err) {
      setErro('Erro ao salvar ambiente');
    }
  };

  const handleDelete = async id => {
    setConfirmarExclusao({ aberto: true, id });
  };

  const confirmarRemocao = async () => {
    try {
      await fetch(`${API_URL}/ambientes/${confirmarExclusao.id}`, { method: 'DELETE' });
      fetchAmbientes();
    } catch {
      setErro('Erro ao remover ambiente');
    }
    setConfirmarExclusao({ aberto: false, id: null });
  };

  const cancelarRemocao = () => {
    setConfirmarExclusao({ aberto: false, id: null });
  };

  // Filtro de pesquisa
  const ambientesFiltrados = ambientes.filter(a =>
    (a.nome || '').toLowerCase().includes(pesquisa.toLowerCase()) ||
    (a.impressora_ip || '').toLowerCase().includes(pesquisa.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={empresa} onVoltar={onVoltar} onSair={onSair} />
      <div className="max-w-5xl mx-auto mt-10 bg-white rounded-lg shadow-lg p-6 relative">
        <h2 className="text-2xl font-bold text-blue-700 mb-6">Ambientes</h2>
        <div className="mb-6 flex justify-end">
          <input
            type="text"
            value={pesquisa}
            onChange={e => setPesquisa(e.target.value)}
            placeholder="Pesquisar por nome ou IP..."
            className="border rounded px-3 py-2 w-full max-w-xs"
          />
        </div>
        {erro && <div className="text-red-600 mb-4">{erro}</div>}
        {loading ? (
          <div>Carregando...</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {ambientesFiltrados.map(a => (
              <div key={a.id} className="bg-blue-50 rounded-lg shadow flex flex-col p-4 relative border border-blue-200">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-bold text-blue-800 text-lg">{a.nome}</span>
                  <div className="flex space-x-2">
                    <button onClick={() => abrirModal(a)} title="Editar" className="text-blue-600 hover:text-blue-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13l6-6 3 3-6 6H9v-3z" /></svg>
                    </button>
                    <button onClick={() => handleDelete(a.id)} title="Excluir" className="text-red-600 hover:text-red-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                    </button>
                  </div>
                </div>
                <div className="text-gray-700 mb-1"><b>Impressora IP:</b> {a.impressora_ip}</div>
                <div className="text-gray-700 mb-1"><b>Impressora Porta:</b> {a.impressora_porta}</div>
                <div className="text-gray-700 mb-1"><b>Impressão Ticket Produção:</b> {listaTipoAmbiente.find(t => String(t.value) === String(a.tipo_ambiente))?.label || '-'}</div>
                <div className="flex justify-between items-center text-gray-700 mb-1">
                  <span><b>Tamanho Bobina:</b> {listaImpressoraTipo.find(t => t.value === a.impressora_tipo)?.label || '-'}</span>
                  <span className="text-xs text-gray-500 font-bold">ID: {a.id}</span>
                </div>
              </div>
            ))}
            {ambientesFiltrados.length === 0 && (
              <div className="col-span-full text-center py-8 text-gray-500">Nenhum ambiente encontrado.</div>
            )}
          </div>
        )}
        {/* Botão flutuante adicionar */}
        <button
          onClick={() => abrirModal()}
          className="fixed bottom-8 right-8 bg-blue-600 text-white rounded-full shadow-lg w-16 h-16 flex items-center justify-center text-3xl hover:bg-blue-700 transition z-50"
          title="Adicionar Ambiente"
        >
          +
        </button>
        {/* Modal de inclusão/edição */}
        {modalAberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md relative">
              <button onClick={fecharModal} className="absolute top-2 right-2 text-gray-400 hover:text-red-600 text-2xl">&times;</button>
              <h3 className="text-xl font-bold text-blue-700 mb-4">{editando ? 'Editar Ambiente' : 'Novo Ambiente'}</h3>
              <form onSubmit={handleSubmit} className="space-y-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nome*</label>
                  <input name="nome" value={form.nome} onChange={handleChange} className="border rounded px-3 py-2 w-full" required maxLength={100} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Impressora IP</label>
                  <input name="impressora_ip" value={form.impressora_ip} onChange={handleChange} className="border rounded px-3 py-2 w-full" maxLength={50} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Impressora Porta</label>
                  <input name="impressora_porta" value={form.impressora_porta} onChange={handleChange} className="border rounded px-3 py-2 w-full" maxLength={10} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Impressão Ticket Produção</label>
                  <select name="tipo_ambiente" value={form.tipo_ambiente} onChange={handleChange} className="border rounded px-3 py-2 w-full">
                    <option value="">Selecione...</option>
                    {listaTipoAmbiente.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Tamanho Bobina</label>
                  <select name="impressora_tipo" value={form.impressora_tipo} onChange={handleChange} className="border rounded px-3 py-2 w-full">
                    <option value="">Selecione...</option>
                    {listaImpressoraTipo.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                  </select>
                </div>
                {erro && <div className="text-red-600 mb-2">{erro}</div>}
                <div className="flex justify-end space-x-2">
                  <button type="button" onClick={fecharModal} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                  <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition">{editando ? 'Salvar' : 'Cadastrar'}</button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* Modal de confirmação de exclusão */}
        {confirmarExclusao.aberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-sm relative">
              <h3 className="text-lg font-bold mb-4">Confirmar exclusão?</h3>
              <div className="flex justify-end gap-2 mt-6">
                <button onClick={cancelarRemocao} className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300">Cancelar</button>
                <button onClick={confirmarRemocao} className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700">Excluir</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AmbientesPage; 